export function useFbqPixel() {
  const isFromFb = computed(() => {
    const params = new URLSearchParams(window?.location?.search)
    return params?.has('fbclid') || !!localStorage.getItem('fbclid')
  })
  return {
    isFromFb,
  }
}
